/** @jsx jsx */
import { jsx, css } from '@emotion/core' // eslint-disable-line
import React, { Component } from 'react' // eslint-disable-line
import { observer } from 'mobx-react'
import * as dayjs from 'dayjs'
import { Table, Icon, Input, Button } from 'antd'
import { GeneralStyles } from '../../../styles/general'

import BusinessStatus from '../../../business/status'
import { userStore } from '../../../store/list/UserModel'
import UserViewer from '../../../components/business/UserViewer'
import StatusTag from '../../../components/StatusTag'

import { buildListPage, LIST_PAGE_TYPES } from '../../list_builder'

import UserListAction from './UserListAction'

const { Search } = Input

interface IUserListProps { }

interface IUserListState {
  searchLoading: boolean
}

interface UserList {
  props: IUserListProps
  state: IUserListState
}

const USER_STATE_COLOR = BusinessStatus.user

const pageColumns = [
  {
    title: '序号',
    dataIndex: 'id',
    key: 'id',
    render: (text: any) => <UserViewer uid={text} />,
  },
  {
    title: '邮箱',
    dataIndex: 'email',
    key: 'email',
    render: (text: any) => <a href="#">{text}</a>,
  },
  {
    title: '注册时间',
    dataIndex: 'create_time',
    key: 'create_time',
    render: (text: any) => (
      <span>{dayjs(text).format('YYYY年MM月DD日 HH:mm:ss')}</span>
    ),
  },
  {
    title: '状态',
    key: 'status',
    dataIndex: 'status',
    render: (status: any, item: any) => {
      return (
        <span>
          <StatusTag item={item} status={status} config={USER_STATE_COLOR} />
        </span>
      )
    },
  },
  {
    title: '操作',
    key: 'action',
    render: (text: any, record: any) => {
      return <UserListAction text={text} record={record} />
    },
  },
]

@observer
class UserList extends Component {
  constructor(props: IUserListProps) {
    super(props)

    this.state = {
      searchLoading: false,
    }
  }

  componentDidMount() {
    userStore.loadPageList()
  }

  reloadList = () => {
    userStore.reloadCurrentPage()
  }

  handleTableChange = (pagination: any) => {
    if (pagination['current'] === userStore.listResponse.current) {
      return
    }

    userStore.changePage(pagination['current'])
  }

  searchUser = (uid: any) => {
    this.setState((preState, props) => ({
      searchLoading: true,
    }))
    userStore
      .loadPageList({ uid })
      .then(() => {
        this.setState((preState, props) => ({
          searchLoading: false,
        }))
      })
  }

  render() {
    const listResponse = userStore.listResponse
    const pageList = listResponse.list.map((item: any) => {
      return {
        key: item['id'],
        ...item,
      }
    })
    const loadState = userStore.listError

    return (
      <div className="general-page" css={GeneralStyles['general-page']}>
        <div css={GeneralStyles['page-head']}>
          <div className="head-title">
            <span className="title-text"><Icon type="team" /> 用户列表</span>
          </div>
        </div>
        <div css={GeneralStyles['page-content']}>
          <div css={GeneralStyles['content-pane']} className="content-pane">
            <div css={GeneralStyles['simple-pane-inner']}>
              <div className="simple-line-item">
                <Button icon="reload" onClick={this.reloadList} />
              </div>
              <div className="simple-line-item">
                <Search
                  placeholder="输入用户id"
                  loading={this.state.searchLoading}
                  onSearch={this.searchUser}
                />
              </div>
            </div>
          </div>
          <div css={GeneralStyles['content-pane']} className="content-pane">
            <Table
              columns={pageColumns}
              rowKey={(record: any) => record.id}
              dataSource={pageList}
              pagination={{
                current: listResponse.current,
                total: listResponse.total,
                pageSize: listResponse.size,
              }}
              loading={loadState.state === 'loading'}
              onChange={this.handleTableChange}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default buildListPage(LIST_PAGE_TYPES.USER, UserList)
